$(function () {
  $(".btnmore").click(function () {
    if ($(this).html() == "more ...") {
      $(this).html("less.");
      $(".more")
        .css({
          opacity: "0",
          display: "inline",
        })
        .animate({ opacity: "1" });
    } else {
      $(this).html("more ...");
      $(".more").hide();
    }
  });
});
